{
  "proposalsTitle": "Mga panukala",
  "proposalsLead": "Mga ideya ng mga residente para sa bayan. Suportahan ang mga sang-ayon ka; sinasagot ng LGU ang bawat isa.",
  "submitProposal": "Magpasa ng panukala",
  "sortSupport": "Pinakamaraming suporta",
  "sortNew": "Pinakabago",
  "allBarangays": "Lahat ng barangay",
  "allStatuses": "Anumang katayuan",
  "townWide": "Buong bayan",
  "noProposals": "Wala pang panukala",
  "noProposalsBody": "May ideya ka ba para sa bayan? Ipasa ito. Sinusuri muna ng isang opisina ang bawat panukala bago ito ipakita rito.",
  "supports": "{count} suporta",
  "supportOne": "1 suporta",
  "support": "Suportahan",
  "supported": "Sinusuportahan mo",
  "unsupport": "Bawiin ang suporta ko",
  "signInToSupport": "Mag-sign in para sumuporta",
  "supportClosed": "Sarado na ang panukalang ito.",
  "pst_open": "Bukas sa suporta",
  "pst_under_review": "Sinusuri",
  "pst_accepted": "Tinanggap",
  "pst_in_progress": "Isinasagawa",
  "pst_done": "Tapos na",
  "pst_not_pursued": "Hindi itutuloy",
  "mod_pending": "Naghihintay ng pagsusuri",
  "mod_published": "Nailathala",
  "mod_declined": "Hindi nailathala",
  "officialResponse": "Sagot ng {office}",
  "lastUpdated": "Huling na-update ng {office} noong {date}",
  "myProposals": "Aking mga panukala",
  "pendingNote": "Susuriin muna ng isang opisina ang panukala mo bago ito makita ng publiko. Aabisuhan ka.",
  "declinedNote": "Hindi nailathala ang panukalang ito: {reason}",
  "withdraw": "Bawiin",
  "withdrawTitle": "Bawiin ang panukalang ito?",
  "withdrawBody": "Mabubura ito. Puwede kang magpasa ng bago anumang oras.",
  "withdrawn": "Nabawi na ang panukala mo.",
  "proposalNotFound": "Hindi available ang panukalang ito.",
  "newProposalTitle": "Magpasa ng panukala",
  "newProposalLead": "Ilarawan ang gusto mong gawin ng LGU at kung bakit. Tungkol sa bayan dapat ito, hindi tungkol sa isang tao.",
  "proposalTitle": "Pamagat",
  "proposalTitleHint": "Maikli at malinaw, hal. \"May lilim na upuan sa plaza\".",
  "proposalDescription": "Ang panukala mo",
  "proposalDescriptionHint": "Ano ang dapat gawin, saan, at sino ang makikinabang.",
  "whereFor": "Para sa aling lugar?",
  "photo": "Larawan",
  "sendForReview": "Ipadala para masuri",
  "sending": "Ipinapadala…",
  "sentTitle": "Naipadala para masuri",
  "sentBody": "Susuriin muna ito ng isang opisina bago makita ng publiko. Makakatanggap ka ng abiso.",
  "viewIt": "Tingnan",
  "checkForm": "Pakisuri ang mga naka-highlight na field.",
  "lostFoundTitle": "Nawala at natagpuan",
  "lostFoundLead": "May nawala o may natagpuan ka? Sinusuri muna ng LGU ang mga post, at dumadaan sa opisina ang pakikipag-ugnayan, hindi direkta.",
  "postItem": "Mag-post ng gamit",
  "kind_lost": "Nawala",
  "kind_found": "Natagpuan",
  "kindAll": "Lahat",
  "allCategories": "Lahat ng uri ng gamit",
  "cat_id_documents": "ID at dokumento",
  "cat_wallet_money": "Pitaka o pera",
  "cat_phone_electronics": "Cellphone o elektroniko",
  "cat_keys": "Susi",
  "cat_bag": "Bag",
  "cat_pet": "Alagang hayop",
  "cat_jewelry": "Alahas",
  "cat_clothing": "Damit",
  "cat_other": "Iba pa",
  "noItems": "Walang naka-post ngayon",
  "noItemsBody": "Lalabas dito ang mga post pagkatapos itong suriin ng isang opisina.",
  "lfst_open": "Bukas",
  "lfst_resolved": "Naibalik",
  "lfst_closed": "Sarado",
  "lfst_expired": "Nag-expire",
  "lostOn": "Nawala noong {date}",
  "foundOn": "Natagpuan noong {date}",
  "myPosts": "Aking mga post",
  "myMessages": "Aking mga mensahe sa opisina",
  "privacyNote": "Huwag mag-post ng ID, mukha o buong pangalan. Ilarawan ang gamit; ang opisina ang magsusuri kung kanino ito.",
  "itemNotFound": "Hindi available ang post na ito.",
  "newItemTitle": "Mag-post ng gamit",
  "whatHappened": "Ano ang nangyari?",
  "iLost": "May nawala sa akin",
  "iFound": "May natagpuan ako",
  "itemTitle": "Ano ito?",
  "itemTitleHint": "Halimbawa: \"Itim na pitaka\" o \"Mga susi sa pulang lanyard\".",
  "category": "Uri ng gamit",
  "itemDescription": "Paglalarawan",
  "itemDescriptionHint": "Kulay, brand, laki: anumang makatutulong, pero walang nagpapakilala sa isang tao.",
  "date": "Kailan?",
  "place": "Saan?",
  "placeHint": "Isang palatandaan, ruta ng dyip o gusali.",
  "privateDetail": "Detalyeng ang opisina lang ang dapat makaalam",
  "privateDetailHint": "Opsyonal. Isang bagay na ang may-ari lang ang nakakaalam (laman, marka). Hindi ito ipinapakita sa publiko at nakatutulong sa opisina na suriin ang mga nagke-claim.",
  "itemSent": "Naipadala ang post mo para masuri.",
  "itemPending": "Susuriin muna ng isang opisina ang post mo bago ito makita ng publiko.",
  "itemDeclined": "Hindi nailathala: {reason}",
  "claimsReceived": "{count} tao ang kumontak sa opisina tungkol dito.",
  "renew": "Panatilihing bukas nang 60 araw pa",
  "renewed": "Bukas ang post mo nang 60 araw pa.",
  "closeMine": "Naibalik na sa akin / Naayos na",
  "closePending": "Burahin ang post ko",
  "closeTitle": "Isara ang post na ito?",
  "closeBody": "Hindi na ito makikita ng iba.",
  "closeYes": "Oo, isara",
  "closed": "Naisara ang post mo.",
  "expiresOn": "Bukas hanggang {date}",
  "privateShown": "Ikaw at ang opisina lang ang nakakakita nito: {detail}",
  "claimLost": "Natagpuan ko ito",
  "claimFound": "Baka akin ito",
  "claimLeadLost": "Sabihin sa opisina kung saan mo ito natagpuan. Kokontakin nila ang may-ari.",
  "claimLeadFound": "Ilarawan ito para masuri ng opisina na sa iyo nga (laman, marka, kung saan mo naiwala).",
  "claimMessage": "Ang mensahe mo sa opisina",
  "claimSend": "Ipadala sa opisina",
  "claimSent": "Naipadala. Susuriin ito ng opisina at kokontakin ka.",
  "claimStatus": "Ang mensahe mo: {status}",
  "cst_new": "Naipadala",
  "cst_in_contact": "Nakikipag-ugnayan ang opisina",
  "cst_confirmed": "Nakumpirma",
  "cst_rejected": "Hindi tugma",
  "signInToClaim": "Mag-sign in para kontakin ang opisina tungkol sa gamit na ito",
  "contactName": "Ang pangalan mo",
  "contactMobile": "Numero ng mobile",
  "contactHint": "Tatawag o magte-text ang opisina sa iyo. Hindi ito ipapakita sa iba.",
  "modTitle": "Pag-moderate ng komunidad",
  "modLead": "Suriin ang mga panukala at post sa nawala at natagpuan bago ito makita ng publiko, sagutin ang mga panukala, at asikasuhin ang mga mensahe tungkol sa mga gamit.",
  "tabPendingProposals": "Panukalang susuriin",
  "tabProposals": "Nailathalang panukala",
  "tabPendingItems": "Post na susuriin",
  "tabClaims": "Mga mensahe",
  "tabItems": "Nailathalang post",
  "statPendingProposals": "Panukalang susuriin",
  "statOpenProposals": "Bukas na panukala",
  "statPendingItems": "Post na susuriin",
  "statClaims": "Bukas na mensahe",
  "nothingHere": "Walang laman ngayon",
  "submittedBy": "Mula kay {name} · {date}",
  "deletedAccount": "Binurang account",
  "publish": "Ilathala",
  "decline": "Huwag ilathala",
  "declineTitle": "Huwag ilathala ito?",
  "declineReason": "Dahilan para sa nagpasa",
  "declineReasonHint": "Makikita nila ito. Maging mabait at tiyak.",
  "reasonRequired": "Sumulat ng maikling dahilan.",
  "published": "Nailathala. Naabisuhan na ang nagpasa.",
  "declined": "Hindi nailathala. Naabisuhan na ang nagpasa.",
  "answer": "I-update ang katayuan",
  "answerTitle": "I-update ang panukalang ito",
  "status": "Katayuan",
  "response": "Pampublikong sagot",
  "responseHint": "Ipinapakita sa panukala at ipinapadala sa nagpasa at mga sumuporta.",
  "answered": "Na-save. Naabisuhan na ang nagpasa at mga sumuporta.",
  "resolve": "Markahang naibalik",
  "closeItem": "Isara",
  "renewItem": "I-renew nang 60 araw",
  "resolveTitle": "Isara ang post na ito?",
  "resolveState": "Paano ito natapos?",
  "resolvedOpt": "Naibalik sa may-ari",
  "closedOpt": "Isinara (hindi naibalik)",
  "note": "Paalala sa nag-post",
  "resolvedToast": "Naisara ang post. Naabisuhan na ang nag-post.",
  "renewedToast": "Na-renew ang post nang 60 araw.",
  "posterContact": "Ipinost ni {name}",
  "privateDetailStaff": "Pribadong detalye: {detail}",
  "noPrivateDetail": "Walang ibinigay na pribadong detalye.",
  "claimAbout": "Tungkol sa: {title}",
  "claimFrom": "Mula kay {name}",
  "claimUpdate": "I-update",
  "claimUpdateTitle": "I-update ang mensaheng ito",
  "claimNote": "Paalala sa nagpadala",
  "claimNoteHint": "Makikita nila ito, hal. kung saan kukunin ang gamit.",
  "claimSaved": "Na-save. Naabisuhan na ang nagpadala.",
  "openClaims": "{count} bukas na mensahe",
  "readOnly": "Makikita mo lang. Ang mga editor at pinuno ng opisina ang naglalathala, sumasagot at nagsasara ng mga post."
}
